<template>
  <div class="detail">
    <div class="container-auto">
      <div class="breadcrumbs">首页-新闻资讯-详情</div>
      <div class="detail-content">
        <div class="detail-header">
          <div class="detail-title">{{ details.title }}</div>
          <div class="detail-info">发布时间：{{ details.publishDate }}</div>
        </div>
        <div class="detail-main" v-html="details.content">
        </div>
        <div class="news_fujian"  v-if="!!details.upload">
          <h4>附件</h4>
          <div v-html="details.upload" class="content"></div>
        </div>
        <div class="detail-paging" v-if="preData || nextData">
          <div class="paging-prev" v-if="preData" @click="gotoDetail(preData.id)">上一篇：{{preData.title}}</div>
          <div class="paging-next" v-if="nextData" @click="gotoDetail(nextData.id)">下一篇：{{nextData.title}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getPolicyByIdNew, queryPolicyAll} from "@/api";
export default {
  data() {
    return {
      id: this.$route.query.id,
      action: this.$route.query.action,
      details: {},
      policyList: [],
      preData: null,
      nextData: null,
    };
  },
  methods: {
    async fetch() {
      const res = await getPolicyByIdNew(this.id);
      this.details = res.result || {};
      let nowIndex = 0
      this.policyList.forEach((item, index) => {
        if (item.id === this.id) {
          nowIndex = index
        }
      })
      console.log( this.policyList)
      console.log( nowIndex)
      if (nowIndex - 1 >= 0) {
        this.preData = this.policyList[nowIndex - 1]
      }
      if (nowIndex + 1 <= this.policyList.length) {
        this.nextData = this.policyList[nowIndex + 1]
      }
    },
    async getPolicy(){
      let param = {
        applicationScenario: "sbgx",
        articletype: this.action,
        type: "sbgx"
      }
      const policyRes = await queryPolicyAll(param)
      this.policyList = policyRes.result || [];
    },
    gotoDetail(id) {
      this.id = id
      this.fetch()
    },
  },
  mounted() {
    this.getPolicy()
    setTimeout(() => {
      this.fetch()
    }, 700);
  },
};
</script>

<style scoped lang="scss">
.detail {
  min-height: 100vh;
  background: #F3F3F8 url("~@/assets/img/policy/bg.png") no-repeat center top;
  background-size: 100% auto;
  padding-bottom: 50px;

  .breadcrumbs {
    font-size: 16px;
    line-height: 19px;
    color: #333333;
    padding: 20px 0;
  }

  .detail-content {
    width: 100%;
    //min-height: calc(100vh - 110px);
    min-height: auto;
    border-radius: 3px;
    background: #FFFFFF;
    box-shadow: 0px 3px 7px 0px rgba(188, 188, 188, 0.5);
    display: flex;
    flex-direction: column;
    padding-bottom: 40px;

    .detail-header {
      padding: 12px 20px 24px;
      background: #F9F9F9;
      text-align: center;
      position: relative;

      &::after {
        content: "";
        position: absolute;
        width: calc(100% - 40px);
        left: 20px;
        bottom: 0;
        height: 1px;
        background: #e8e8e8;
      }

      .detail-title {
        font-size: 24px;
        line-height: 65px;
        text-align: center;
        color: #333333;
      }

      .detail-info {
        font-size: 16px;
        font-weight: normal;
        line-height: 24px;
        color: #666666;
      }
    }

    .detail-main{
      padding: 30px 60px;
      font-size: 16px;
      line-height: 30px;
      color: #555555;
      flex: 1;
    }
    .news_fujian {
      padding: 10px 0;
      width: calc(100% - 32px);
      margin: 30px 60px;
      clear: both;

      h4 {
        font-size: 12px;
        color: #999;
        margin: 0 0 10px 0;
      }

      .content{
        word-break: break-all;
      }

      a {
        color: #3f76ef;
        font-size: 12px;
        margin-bottom: 10px;
        display: block;
        text-decoration: underline;
      }

      &.news-detail-old {
        h4 {
          font-size: 18px !important;
        }

        .content {
          font-size: 18px !important;
          ::v-deep p {
            font-size: 18px !important;
            ::v-deep  a {
              font-size: 18px !important;
              line-height: 26px !important;
            }
          }
        }
      }
    }
  }

  .detail-paging{
    width: 1125px;
    background: #F2F2F2;
    margin: 0 auto;
    padding: 5px 30px;
    font-size: 16px;
    line-height: 40px;
    color: #555B89;

    .paging-prev {
      cursor: pointer;
    }

    .paging-next {
      cursor: pointer;
    }
  }
}
</style>
